var exports = {
  "normal": "normal__V7mAQu",
  "none": "none__p49WnN",
  "condensed": "condensed__uWaX7O",
  "spacious": "spacious__gaHZ4N",
};

__webpack_require__.r(module.exports = exports);
